<template>
  <p-app theme="glittr" class="layout admin core">
    <template slot="header">
      <p-toolbar>
        <p-row align-center dense>
          <p-button
            secondary
            spacious
            @click="isSidedrawerVisible = !isSidedrawerVisible"
          >
            <p-icon> menu </p-icon>
          </p-button>
        </p-row>
        <p-row justify-end align-center>
          <il-language-selection></il-language-selection>
          <p-menu v-model="profileMenuVisible" bottom left>
            <template slot="activator">
              <p-button color="text" dense>
                <p-icon dense>
                  person
                </p-icon>
              </p-button>
            </template>
            <p-card>
              <p-row column>
                <router-link to="/_me/profile" tag="p-button">
                  {{ $t("core.page.profile.button.showProfile") }}
                  <p-icon right>
                    manage_accounts
                  </p-icon>
                </router-link>
                <p-divider></p-divider>
                <p-button @click="doLogoff">
                  {{ $t("core.page.profile.button.logoff") }}
                  <p-icon right>
                    exit_to_app
                  </p-icon>
                </p-button>
              </p-row>
            </p-card>
          </p-menu>
        </p-row>
      </p-toolbar>
    </template>

    <p-side-drawer v-model="isSidedrawerVisible" :overlay="$media.isMobile">
      <p-list-group>
        <p-list class="mt-3" spacious>
          <p-list-entry to="/_admin/dashboard" icon-left="dashboard">
            {{ $t('page.dashboard.page.title') }}
          </p-list-entry>
          <p-list-entry to="/_admin/processes" icon-left="account_tree">
            {{ $t("core.page.processes.page.title") }}
          </p-list-entry>
          <p-list-entry :to="`/_admin/applog?levels=error&datefrom=${date}`" icon-left="list">
            {{ $t('page.applog.page.title') }}
          </p-list-entry>
          <p-list-entry :to="`/_admin/calllog?datefrom=${date}`" icon-left="list">
            {{ $t('page.calllog.page.title') }}
          </p-list-entry>
          <p-list-entry to="/_hostadmin/users" icon-left="person">
            {{ $t('page.user.page.title') }}
          </p-list-entry>
          <p-list-entry :to="`/_admin/integrationlog?datefrom=${date}`" icon-left="compare_arrows">
            {{ $t("core.page.integrationlog.page.title") }}
          </p-list-entry>
          <p-list-entry to="/_admin/contactidmapping" icon-left="social_distance">
            {{ $t("core.page.contactidmapping.page.title") }}
          </p-list-entry>
          <p-list-entry to="/_admin/fieldmapping" icon-left="list">
            {{ $t('page.fieldmapping.index.page.title') }}
          </p-list-entry>
        </p-list>
      </p-list-group>
      <template slot="content">
        <slot></slot>
      </template>
    </p-side-drawer>
  </p-app>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    auth: true,
    data: () => ({
      date: Vue.$date.now().format('YYYY-MM-DD'),
      profileMenuVisible: false,
      isSidedrawerVisible: true,
    }),
    beforeMount() {
      this.isSidedrawerVisible = this.$localStorage.get<boolean>('isSidedrawerVisible') ?? true;
    },
    methods: {
      async doLogoff() {
        try {
          await this.$auth.logout();
          this.$router.push('/_exterior/login');
        } catch (error) {
          Vue.$log.error('Unable to log out an error occurred');
          Vue.$log.error(error);
        }
      },
      toggleSideDrawerVisible() {
        this.isSidedrawerVisible = !this.isSidedrawerVisible;
        this.$localStorage.set('isSidedrawerVisible', this.isSidedrawerVisible);
      },
    },
  });
</script>
